import { render, staticRenderFns } from "./group-perception.vue?vue&type=template&id=80bbc77c&"
import script from "./group-perception.vue?vue&type=script&lang=ts&"
export * from "./group-perception.vue?vue&type=script&lang=ts&"
import style0 from "./group-perception.vue?vue&type=style&index=0&id=80bbc77c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports